import { Color } from '@material-ui/core';

const blue: Color = {
  50: '#e8e9f4',
  100: '#c5c8e4',
  200: '#9fa4d3',
  300: '#787fc1',
  400: '#5b63b3',
  500: '#3e48a6',
  600: '#38419e',
  700: '#303895',
  800: '#28308b',
  900: '#1b217b',
  A100: '#b5b9ff',
  A200: '#8289ff',
  A400: '#4f59ff',
  A700: '#3640ff',
};

export default blue;
